<template>
  <v-card flat :color="$vuetify.theme.dark ? '#2d2d2d' : '#f9fafb'" height="101%">
    <v-row v-resize="onResize">
      <v-col cols="2">
        <v-navigation-drawer
          :absolute="drawerAbsolute"
          permanent
          v-model="drawerState"
          :max-width="drawerWidth"
          :mini-variant.sync="mini"
          mini-variant-width="60"
          :right="$vuetify.rtl"
          mobile-breakpoint="600"
          :color="$vuetify.theme.dark ? '#1E1E1E' : '#FFFFFF'"
          class="student-list mt-2"
        >
          <v-card flat class="px-1  mt-1" :loading="loading">
            <v-toolbar flat dense class="pa-0 py-4 " width="100%">
              <div class=" mb-4 d-flex " style="height: 60px">
                <v-text-field
                  v-if="!mini"
                  single-line
                  v-model="searchStudent"
                  dense
                  filled
                  hidden-details
                  rounded
                  clearable
                  :placeholder="$t('search')"
                  prepend-inner-icon="mdi-magnify"
                  style="width: 100% !important"
                  class="shrink expanding-search"
                ></v-text-field>
                <v-fab-transition>
                  <v-btn
                    class="mt-1 "
                    icon
                    small
                    depressed
                    top
                    :left="!$vuetify.rtl"
                    :right="$vuetify.rtl"
                    @click="
                      drawerState = !drawerState;
                      mini = !drawerState;
                    "
                  >
                    <v-icon>mdi-menu</v-icon>
                  </v-btn>
                </v-fab-transition>
              </div>
            </v-toolbar>
            <v-divider class="mb-1"></v-divider>
            <v-virtual-scroll
              benched="20"
              :items="studentList"
              :item-height="64"
              style="height: calc(100vh - 120px);"
            >
              <template v-slot:default="{ item }">
                <v-list-item class="pa-0" :key="item.student.studentGuid">
                  <v-list-item-content class="pa-0 ">
                    <profileImage
                      :title="item.student.studentFullName"
                      classCss="mt-3"
                      :size="32"
                      :displayName="truncateWordFromEnd(item.student.studentFullName, 16)"
                      :thumbnail="true"
                      :imageUrl="item.student.profileImageUrl"
                      :stageInfo="{
                        stageName: item.stageName,
                        studyName: item.studyName
                      }"
                    />
                  </v-list-item-content>
                  <v-list-item-action class="ma-0 me-1">
                    <v-btn
                      :title="$t('preview')"
                      depressed
                      fab
                      x-small
                      :to="{
                        name: 'portfolio.student',
                        params: { id: item.student.studentGuid }
                      }"
                    >
                      <v-icon>{{ $vuetify.rtl ? "mdi-chevron-left" : "mdi-chevron-right" }}</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-navigation-drawer>
      </v-col>
      <v-col cols="10" style="z-index: 0;">
        <v-expansion-panels v-model="filterPanel" class="pt-2 px-5">
          <v-expansion-panel style="z-index: 10 !important;">
            <v-expansion-panel-header>{{ $t("degrees.searchFilters") }}</v-expansion-panel-header>
            <v-expansion-panel-content class="pa-2">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    class="ma-1"
                    v-model="filterContent.content"
                    :label="$t('SearchText')"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    class="ma-1"
                    v-model="filterContent.studentName"
                    :label="$t('studentName')"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-select
                    class="ma-1"
                    v-model="filterContent.tags"
                    :label="$t('portfolio.TagsItems.selectTags')"
                    :items="tagsDataSource"
                    dense
                    outlined
                    hide-details
                    return-object
                    item-text="tagName"
                    item-value="tagItemGuid"
                    multiple
                    chips
                    small-chips
                    clearable
                  >
                    <template v-slot:item="{ item }">
                      <v-chip
                        :key="'item_' + item.tagItemGuid"
                        :style="{
                          backgroundColor: $vuetify.theme.dark
                            ? item.tagTextColor
                            : item.tagBackgroundColor,
                          color: $vuetify.theme.dark ? item.tagBackgroundColor : item.tagTextColor,
                          userSelect: 'none'
                        }"
                      >
                        <div class="ms-1">{{ item.tagName }}</div>
                      </v-chip>
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-chip
                        small
                        :key="'item_selection_' + item.tagItemGuid"
                        :style="{
                          backgroundColor: $vuetify.theme.dark
                            ? item.tagTextColor
                            : item.tagBackgroundColor,
                          color: $vuetify.theme.dark ? item.tagBackgroundColor : item.tagTextColor,
                          userSelect: 'none'
                        }"
                      >
                        <div class="ms-1">{{ item.tagName }}</div>
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="d-flex align-center justify-between flex-wrap">
                  <v-checkbox
                    class="ma-1 px-2"
                    v-model="filterContent.itemType"
                    :label="$t('portfolio.WorkSample.title')"
                    value="WorkSample"
                  ></v-checkbox>
                  <v-checkbox
                    class="ma-1  px-2"
                    v-model="filterContent.itemType"
                    :label="$t('portfolio.Achievement.title')"
                    value="Achievement"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row no-gutters
                ><v-col class="d-flex align-center justify-between flex-wrap">
                  <v-checkbox
                    class="ma-1  px-2"
                    :disabled="!filterContent.itemType.includes('WorkSample')"
                    v-model="filterContent.forAttention"
                    :label="$t('portfolio.WorkSample.fields.forAttention')"
                  ></v-checkbox>
                  <v-checkbox
                    class="ma-1  px-2"
                    :disabled="!filterContent.itemType.includes('WorkSample')"
                    v-model="filterContent.flagged"
                    :label="$t('portfolio.WorkSample.fields.flagged')"
                  ></v-checkbox> </v-col
              ></v-row>

              <v-row no-gutters>
                <v-col>
                  <v-btn color="primary" @click="getRecentlyItems(true)" :loading="loadingItems">
                    <v-icon>mdi-magnify</v-icon>
                    {{ $t("search") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-skeleton-loader
          class="mt-1"
          :loading="loadingItems"
          translate="trans"
          type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
        >
          <template #default>
            <v-card
              color="transparent"
              flat
              class="px-2 mt-1"
              v-if="recentlyItems && recentlyItems.length > 0"
            >
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    v-for="(i, index) in recentlyItems"
                    :key="i.guid"
                    lg="3"
                    md="4"
                    sm="12"
                    xs="12"
                  >
                    <BaseCard
                      :icon="i.itemType == 'Achievement' ? 'mdi-trophy' : ''"
                      height="100%"
                      :showIcons="false"
                      :key="i.guid"
                      :imageLink="i.itemType == 'Achievement' ? null : getFirstImage(i.files)"
                      :title="i.title ? i.title : '-'"
                      :description="i.itemType == 'Achievement' ? i.description : i.caseDescription"
                      :studentInfo="i.student"
                      :to="{
                        name: 'portfolio.student',
                        params: { id: i.student.studentGuid }
                      }"
                      @details="navToDetails(i)"
                      coverImageHeight="10rem"
                
                    >
                      <template slot="header-actions">
                        <div class="d-flex align-center  justify-end" style="gap: 0.5rem;">
                          <v-icon
                            v-if="(isInRole(2) && i.flag) || isInRole(0)"
                            :title="$t('portfolio.WorkSample.fields.flagged')"
                            :color="i.flag ? 'error' : 'primary'"
                            >{{ i.flag ? "mdi-flag" : "mdi-flag-outline" }}</v-icon
                          >
                          <v-icon
                            v-if="(isInRole(2) && i.forAttention) || isInRole(0)"
                            :title="$t('portfolio.WorkSample.fields.forAttention')"
                            :color="i.forAttention ? 'warning' : 'primary'"
                            >{{
                              i.forAttention ? "mdi-alert-circle" : "mdi-alert-circle-outline"
                            }}</v-icon
                          >
                        </div>
                      </template>
                      <template slot="content">
                        <v-divider />

                        <div class="d-flex">
                          <div class="ma-2">
                            <TagsMini
                              v-model="i.tags"
                              :sourceGuid="i.guid"
                              :sourceType="i.itemType"
                            />
                          </div>
                        </div>
                        <v-chip
                          class="ms-1 align-self-start"
                          label
                          color="transparent"
                          small
                          :title="i.createdDate | moment('YYYY/MM/DD - h:mm A')"
                        >
                          {{ dateFromNow(i.createdDate) }}
                        </v-chip>
                      </template>
                    </BaseCard>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="d-flex justify-center">
                    <v-pagination
                      v-model="page"
                      :length="Math.ceil(totalItems / pageSize)"
                      circle
                      total-visible="7"
                      @input="getRecentlyItems(false)"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <no-data v-else-if="!loading" />
          </template>
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import NoData from "../../../components/noData.vue";
import profileImage from "../../../components/portfolio/profileImage.vue";
import BaseCard from "../../../components/portfolio/baseCard.vue";
import TagsMini from "../../../components/portfolio/tagsMini.vue";

export default {
  name: "PortfolioGrid",
  components: {
    NoData,
    profileImage,
    BaseCard,
    TagsMini
  },
  data() {
    return {
      loading: false,
      loadingItems: false,
      searchStudent: "",
      filterPanel: false,
      filterContent: {
        content: null,
        studentName: null,
        itemType: ["WorkSample", "Achievement"],
        forAttention: false,
        flagged: false,
        tags: []
      },
      teacherStudents: [],
      recentlyItems: [],
      page: 1,
      pageSize: 8,
      drawerState: true,
      totalItems: 0,
      drawerWidth: 260,
      drawerAbsolute: false,
      mini: false,
      tagsDataSource: []
    };
  },
  created() {
    this.onResize(null);
    this.getTeacherStudents();
    this.getRecentlyItems(false);
  },

  methods: {
    getTeacherStudents() {
      this.loading = true;
      this.axios
        .get("Teachers/GetTeacherStudents")
        .then(response => {
          this.teacherStudents = response.data.data;
        })
        .catch(error => {
          console.error("Error fetching portfolios:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRecentlyItems(search = false) {
        if (search) {
        this.page = 1; // Reset to first page on new search
        this.recentlyItems = [];
        this.totalItems = 0;
        this.tagsDataSource = [];
      }

      var url = "WorkSample/GetRecently";
      url += `?page=${this.page}`;
      url += `&pageSize=${this.pageSize}`;
      url += `&content=${this.filterContent.content || ""}`;
      url += `&studentName=${this.filterContent.studentName || ""}`;
      url += `&itemType=${this.filterContent.itemType.join(",")}`;
      url += `&forAttention=${this.filterContent.forAttention}`;
      url += `&flagged=${this.filterContent.flagged}`;
      if (this.filterContent.tags && this.filterContent.tags.length > 0) {
        url += `&tags=${this.filterContent.tags.map(t => t.tagItemGuid).join(",")}`;
      }

    
      this.loadingItems = true;
      this.axios
        .get(url)
        .then(response => {
          this.recentlyItems = response.data.data.items;
          this.totalItems = response.data.data.totalItems;
          this.tagsDataSource = response.data.data.tags;
        })
        .catch(error => {
          console.error("Error fetching dashboard items:", error);
        })
        .finally(() => {
          this.loadingItems = false;
        });
    },
    getFirstImage(files) {
      if (!files || !Array.isArray(files) || files.length === 0) return null;
      const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"];
      const firstImage = files.find(file =>
        imageExtensions.some(ext => file.fileName.toLowerCase().endsWith(ext))
      );
      return firstImage ? firstImage.fileUrl : null;
    },
    navToDetails(i) {
      if (i.itemType === "Achievement") {
        this.$router.push({ name: "portfolio.Achievement.details", params: { id: i.guid } });
      } else if (i.itemType === "WorkSample") {
        this.$router.push({
          name: "portfolio.WorkSample.details",
          params: { id: i.guid }
        });
      }
    },
    onResize(e) {
      var innerWidth = window.innerWidth;
      if (innerWidth > 1325) {
        this.drawerAbsolute = false;
      } else if (innerWidth < 1325) {
        this.drawerAbsolute = true;
      }
    },
    truncateWordFromEnd(str, length) {
      if (!str || str.length <= length) return str;
      // If string is longer than length, remove the last word
      let words = str.split(" ");
      if (words.length <= 1) {
        // If only one word, just truncate to length
        return str.slice(0, length);
      }
      // Remove last word and join the rest
      words.pop();
      let truncated = words.join(" ");
      // If still longer than length, keep removing last word
      while (truncated.length > length && words.length > 1) {
        words.pop();
        truncated = words.join(" ");
      }
      // If after removing words it's still too long, slice to length
      if (truncated.length > length) {
        return truncated.slice(0, length);
      }
      return truncated;
    }
  },
  computed: {
    studentList() {
      if (!this.teacherStudents || this.teacherStudents.length === 0) {
        return [];
      }

      if (!this.searchStudent) {
        return this.teacherStudents;
      }
      return this.teacherStudents.filter(item =>
        item.student.studentFullName.toLowerCase().includes(this.searchStudent.toLowerCase())
      );
    }
  }
};
</script>

<style>
.student-list .v-navigation-drawer__content {
  padding-bottom: 0px !important;
}
</style>
